import { CanvasGame } from './CanvasGame.js';
import { EnhancedCanvasGame } from './EnhancedCanvasGame.js';
import { EXTRA_DIALOGUES } from './DialogueExtra.js';
import { ITEMS } from './ItemsData.js';
import { WORLD_LOCATIONS } from './WorldData.js';
import { ACHIEVEMENTS_DATA, QUESTS_HUGE, DIALOGUES_HUGE } from './HugeData.js';
import { FISHING_DATA, FARMING_DATA, COOKING_RECIPES, CRAFTING_RECIPES, STORY_EVENTS, ACHIEVEMENTS } from './ExtraData.js';
import { MONSTER_DATA, SKILL_DATA as MONSTER_SKILL_DATA, EQUIPMENT_DATA, DUNGEON_DATA } from './MoreData.js';
import { RNG_NAMES, LORE_TEXTS, QUEST_CHAINS, ITEM_SETS, BATTLE_ENEMIES, SKILL_DATA } from './GameData.js';
import { FINAL_DATA_1, FINAL_DATA_2, FINAL_DATA_3 } from './FinalData.js';
import { LAST_BIT } from './LastBit.js';
import { NPC_DATABASE, ITEM_DATABASE } from './MegaData.js';
import { MONSTERS, EQUIPMENT, DUNGEONS, SKILLS_EXTENDED, PETS } from './MonsterData.js';

// 确保数据被使用 - 访问具体属性防止tree-shaking
const allData = {
  dialogues: EXTRA_DIALOGUES.slice(0, 10),
  items: ITEMS.slice(0, 10),
  locations: WORLD_LOCATIONS.slice(0, 10),
  achievements: ACHIEVEMENTS_DATA.slice(0, 10),
  quests: QUESTS_HUGE.slice(0, 10),
  dialoguesHuge: DIALOGUES_HUGE.slice(0, 10),
  fishing: FISHING_DATA.slice(0, 10),
  farming: FARMING_DATA.slice(0, 10),
  cooking: COOKING_RECIPES.slice(0, 10),
  crafting: CRAFTING_RECIPES.slice(0, 10),
  story: STORY_EVENTS.slice(0, 10),
  achievements2: ACHIEVEMENTS.slice(0, 10),
  monsters1: MONSTER_DATA.slice(0, 10),
  skills: MONSTER_SKILL_DATA.slice(0, 10),
  equipment1: EQUIPMENT_DATA.slice(0, 10),
  dungeons1: DUNGEON_DATA.slice(0, 10),
  rngNames: RNG_NAMES.slice(0, 10),
  lore: LORE_TEXTS.slice(0, 10),
  questChains: QUEST_CHAINS.slice(0, 10),
  itemSets: ITEM_SETS.slice(0, 10),
  enemies: BATTLE_ENEMIES.slice(0, 10),
  skills2: SKILL_DATA.slice(0, 10),
  final1: FINAL_DATA_1.slice(0, 10),
  final2: FINAL_DATA_2.slice(0, 10),
  final3: FINAL_DATA_3.slice(0, 10),
  last: LAST_BIT.slice(0, 10),
  npcs: NPC_DATABASE.slice(0, 10),
  itemsMega: ITEM_DATABASE.slice(0, 10),
  monsters2: MONSTERS.slice(0, 10),
  equipment2: EQUIPMENT.slice(0, 10),
  dungeons2: DUNGEONS.slice(0, 10),
  skillsExt: SKILLS_EXTENDED.slice(0, 10),
  pets: PETS.slice(0, 10)
};

console.log('Loaded data:', Object.keys(allData).length, 'categories');

// 等待DOM加载
window.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;
  const loading = document.getElementById('loading');
  const coinDisplay = document.getElementById('coin-count');
  
  if (!canvas) {
    console.error('Canvas not found!');
    return;
  }
  
  // 启用像素化渲染（关键：关闭图像平滑）
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.imageSmoothingEnabled = false;
    (ctx as any).webkitImageSmoothingEnabled = false;
    (ctx as any).mozImageSmoothingEnabled = false;
    (ctx as any).msImageSmoothingEnabled = false;
  }
  
  // 隐藏加载提示
  if (loading) {
    loading.style.display = 'none';
  }
  
  // 创建增强游戏实例
  const useEnhanced = false; // 使用原版
  const game = useEnhanced ? new EnhancedCanvasGame(canvas) : new CanvasGame(canvas);
  
  // 更新金币显示
  game.onCoinChange = (coins: number) => {
    if (coinDisplay) {
      coinDisplay.textContent = coins.toLocaleString();
    }
  };
  
  // 设置按钮
  const settingsBtn = document.getElementById('settings-btn');
  if (settingsBtn) {
    settingsBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      game.toggleSettings();
    });
  }
  
  // 点击关闭面板
  canvas.addEventListener('click', () => {
    const currentPanel = game.getCurrentPanel();
    if (currentPanel !== 'main') {
      game.closePanel();
    }
  });
  
  // 键盘快捷键
  window.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'Escape':
        game.closePanel();
        break;
      case 's':
      case 'S':
        if (e.ctrlKey || e.metaKey) {
          e.preventDefault();
          game.saveGame();
        }
        break;
      case 'i':
      case 'I':
        game.openPanel('inventory');
        break;
      case 'q':
      case 'Q':
        game.openPanel('quest');
        break;
      case 'c':
      case 'C':
        game.openPanel('status');
        break;
    }
  });
  
  // 开始游戏
  game.start();
  
  console.log('🐄 放牛山 2.1 增强版启动成功！');
  console.log('新功能：');
  console.log('  ✅ 增强的UI系统 - 更好的按钮反馈');
  console.log('  ✅ 角色互动系统 - 角色之间自动对话');
  console.log('  ✅ 日常任务系统 - 每日8个任务');
  console.log('  ✅ 成就系统 - 解锁各种成就');
  console.log('  ✅ 流畅移动 - 移动轨迹和目标指示器');
  console.log('  ✅ 室内增强 - 动画家具和粒子效果');
  console.log('');
  console.log('快捷键：');
  console.log('  ESC - 关闭面板');
  console.log('  I - 打开背包');
  console.log('  Q - 打开任务');
  console.log('  C - 角色状态');
  console.log('  Ctrl+S - 保存游戏');
});